import { render } from "./SideModal.vue?vue&type=template&id=cd065624&scoped=true"
import script from "./SideModal.vue?vue&type=script&lang=js"
export * from "./SideModal.vue?vue&type=script&lang=js"

import "./SideModal.vue?vue&type=style&index=0&id=cd065624&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd065624"]])

export default __exports__